import { useReactNavigationLink } from "./useReactNavigationLink";
import { useSolitoLink } from "./useSolitoLink";

export const useLink =
  process.env.NEXT_PUBLIC_ENABLE_SOLITO === "true"
    ? useSolitoLink
    : useReactNavigationLink;
